export const fontSize = (
  fontMin: number,
  fontMax: number,
  screenMin = 375,
  screenMax = 1920
) => `
  font-size: calc(${fontMin}px + (${fontMax} - ${fontMin}) * ((100vw - ${screenMin}px) / (${screenMax} - ${screenMin})));
`;

type TypographyType = {
  fontMin: number;
  fontMax: number;
  lineHeight: number;
  fontWeight: number;
};

// изначально заложила ф-ю масштабирования шрифтов для адаптива
// т.к. адаптива нет, решила ф-ю не убирать, поэтому мин и макс размер шрифта одинаковый
// в будущем, если потребуется адаптив, можно задать мин размер шрифтов для мобилок, и шрифт будет плавно изменять размер от своих min и max значений
export const createTypography = ({
  fontMin,
  fontMax,
  lineHeight,
  fontWeight,
}: TypographyType) => {
  return `font-weight: ${fontWeight}; font-family: 'Roboto'; line-height: ${lineHeight};
          ${fontSize?.(fontMin, fontMax)}`;
};

export const typography = {
  font_size: {
    base: "16px",
  },
  line_height: {
    default: "1.5",
  },
  font_weight: {
    medium: 500,
  },
  body_large_regular: createTypography({
    fontMin: 16,
    fontMax: 16,
    lineHeight: 1.5,
    fontWeight: 400,
  }),
  body_large_medium: createTypography({
    fontMin: 16,
    fontMax: 16,
    lineHeight: 1.5,
    fontWeight: 500,
  }),
  body_medium_regular: createTypography({
    fontMin: 14,
    fontMax: 14,
    lineHeight: 1.5,
    fontWeight: 400,
  }),
  body_small_medium: createTypography({
    fontMin: 14,
    fontMax: 14,
    lineHeight: 1.4,
    fontWeight: 500,
  }),
  body_small_regular: createTypography({
    fontMin: 12,
    fontMax: 12,
    lineHeight: 1.333,
    fontWeight: 400,
  }),
  label_large: createTypography({
    fontMin: 14,
    fontMax: 14,
    lineHeight: 1.4,
    fontWeight: 500,
  }),
  label_small_medium: createTypography({
    fontMin: 11,
    fontMax: 11,
    lineHeight: 1.45,
    fontWeight: 500,
  }),
  label_medium: createTypography({
    fontMin: 12,
    fontMax: 12,
    lineHeight: 1.45,
    fontWeight: 500,
  }),
  headline_small: createTypography({
    fontMin: 24,
    fontMax: 24,
    lineHeight: 1.3333,
    fontWeight: 400,
  }),
  headline_large: createTypography({
    fontMin: 32,
    fontMax: 32,
    lineHeight: 1.25,
    fontWeight: 400,
  }),
  display_large: createTypography({
    fontMin: 57,
    fontMax: 57,
    lineHeight: 1.12,
    fontWeight: 400,
  }),
  display_medium: createTypography({
    fontMin: 45,
    fontMax: 45,
    lineHeight: 1.15,
    fontWeight: 500,
  }),
  display_small: createTypography({
    fontMin: 36,
    fontMax: 36,
    lineHeight: 1.22,
    fontWeight: 500,
  }),
  title_large: createTypography({
    fontMin: 22,
    fontMax: 22,
    lineHeight: 1.27,
    fontWeight: 400,
  }),
  title_medium: createTypography({
    fontMin: 16,
    fontMax: 16,
    lineHeight: 1.5,
    fontWeight: 500,
  }),
};
